import { RootState } from "@/store/type";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import EditProfileFormView from "@/pages/profile/components/edit-profile-form-view";
import ProfileFormView from "@/pages/profile/components/profile-form-view";

export default function ProfilePage() {
  const authUser = useSelector((state: RootState) => state.auth.authUser);
  const userId = authUser.id;
  return (
    <div className="flex flex-col">
      <div className="w-full overflow-auto">
        {!isEmpty(userId) ? (
          <EditProfileFormView />
        ) : (
          <section className="w-full max-w-xs xs:justify-center bg-primary-white p-5 rounded-md xs:max-w-5xl py-6">
            <ProfileFormView />{" "}
          </section>
        )}
      </div>
    </div>
  );
}
